<template lang="pug">
  div.classifier.tech-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование технологии"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="object_name"
                  inputType="input"
                  label="Наименование установки/объекта"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="tech_target_id"
                  inputType="select"
                  :options="techTargets"
                  :required="true"
                  label="Назначение технологии"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  v-if="fields.tech_target_id === -1"
                  name="newTechTargetName"
                  :required="true"
                  label="Иное назначение технологии"
                  placeholder="Введите назначение"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="cadastr"
                  inputType="input"
                  label="Код технологии в кадастре"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="description"
                  inputType="textarea"
                  label="Описание технологии"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="has_project"
                  :model="fields"
                  tabView="tab1"
                  inputType="select"
                  :options="yeasOrNoBoolean"
                  label="Наличие проекта на технологию"
                  :required="true"
                )
              
              div.col
                e-form-group(
                  name="start_year"
                  inputType="select"
                  :options="years"
                  :required="true"
                  label="Год ввода в эксплуатацию"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="end_year"
                  inputType="select"
                  :options="years"
                  :required="true"
                  label="Год окончания эксплуатации"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  label="Хозяйствующий субъект"
                  inputType="suggestion"
                  :model="fields"
                  name="tkoOperatorName"
                  @selectItem="onSelectOperator"
                  :minSuggestLen="2"
                  :useInnerSearch="false"
                  :suggestionEndpoint="suggestionOperatorEndpoint"
                  :transformSuggestions="transformOperatorSuggestions"
                  tabView="tab1"
                )
                // p {{fields.tko_operator_id}}
                
                e-form-group(
                  name="actions"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                  label="Вид деятельности"
                  inputType="checkbox[]"
                  optionValueKey="value"
                  optionTextKey="label"
                  :options="ACTIONS"
                )
                
                // p {{fields.actions}}
              
              div.col
                e-form-subtitle(text="Государственная экологическая экспертиза")
                e-form-group(
                  name="has_expertise"
                  :model="fields"
                  tabView="tab1"
                )
                  slot
                    label.checked
                      input.checkbox(
                        type="checkbox"
                        v-model="fields.has_expertise"
                        :true-value="false"
                        :false-value="true"
                      )
                      span Отсутствует
                e-form-group(
                  name="expertise_num"
                  inputType="input"
                  label="Номер"
                  :model="fields"
                  tabView="tab1"
                  :required="fields.has_expertise"
                  :disabled="!fields.has_expertise"
                )
                e-form-group(
                  name="expertise_date"
                  inputType="calendar"
                  label="Дата"
                  :model="fields"
                  tabView="tab1"
                  :required="fields.has_expertise"
                  :disabled="!fields.has_expertise"
                )
                e-form-group(
                  name="expertise_organization"
                  inputType="input"
                  label="Организация"
                  :model="fields"
                  tabView="tab1"
                  :required="fields.has_expertise"
                  :disabled="!fields.has_expertise"
                )
                e-form-group(
                  name="expertise_conclusion"
                  inputType="textarea"
                  label="Вывод экологической экспертизы"
                  :model="fields"
                  tabView="tab1"
                  :disabled="!fields.has_expertise"
                )
              
              
              // вкладка ОТХОДЫ
          div(v-show="tabView === 'tab2'")
            tech-garbage-table(
              :id="fields.id"
              ref="garbageTable"
              tabView="tab2"
              :canUseGarbageProduction="canUseGarbageProduction"
            )
          
          // вкладка ОБЪЕКТЫ
          div(v-if="tabView === 'tab3'")
            div.body.body-table
              div.table-choose-panel
                div.toolbar-table
                  div.select Объекты
              
              objects-table(
                :fields="fields"
              )
          
          //Журнал изменений
          div(v-show="tabView === 'tab4'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )
</template>

<script>
  import { cadastr, core } from '@/api/api-endpoints'
  import techForm from './mixins/tech-form.js'
  import TechGarbageTable from './components/tech-garbage-table.vue'
  import ObjectsTable from './components/objects-table'
  
  export default {
    components: {
      ObjectsTable,
      TechGarbageTable
    },
    mixins: [techForm],
    data() {
      return {
        tabView: 'tab1',
        fields: {
          name: ''
        }
      }
    },
    computed: {
      moduleId() {
        return this.moduleIds['tech']
      },
      tabs() {
        const tabs = [{ tab1: 'Общие сведения' }, { tab2: 'Отходы' }, { tab3: 'Объекты' }]
        if (this.fields.id) {
          tabs.push({ tab4: 'Журнал изменений' })
        }
        return tabs
      }
    },
    methods: {
      getTechTargetsEndpoint() {
        return core.statuses({ fields: 'tech_target' })
      },
      getDeleteUrl(id) {
        return cadastr.techDelete(id)
      },
      getUpdateOrCreateUrl() {
        return cadastr.techUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route) {
        if (!route.params.id) {
          return null
        }
        return cadastr.tech(route.params.id)
      }
    }
  }
</script>
